function getPrecision(scinum) {
  var arr = new Array();
  arr = scinum.split("e");
  var exponent = Math.abs(arr[1]);
  var precision = new Number(exponent);
  if (arr[0].includes(".")) {
    arr = arr[0].split(".");
    precision += arr[1].length;
  }
  if (precision > 9) precision = 9;
  return precision;
}

export function showPrice(price) {
  let sPrice = 0;
  if (price > 1) {
    sPrice = parseFloat(price);
  } else {
    sPrice = price?.toString();
    if (sPrice?.match(/^[-+]?[0-9]?\.?[0-9]+e[-]?[1-9][0-9]*$/)) {
      sPrice = (+sPrice).toFixed(getPrecision(sPrice));
    } else {
      sPrice = (+sPrice)?.toFixed(9);
    }
  }
  if (sPrice.toString().includes("."))
    sPrice = sPrice.toString().replace(/\.?0+$/, "");
  var parts = sPrice.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function convertNumbers2English(string) {
  return string
    .replace(/\./g, "")
    .replace(/\u060C/g, ",")
    .replace(/[\u0660-\u0669]/g, function (c) {
      return c.charCodeAt(0) - 0x0660;
    })
    .replace(/[\u06f0-\u06f9]/g, function (c) {
      return c.charCodeAt(0) - 0x06f0;
    });
}
export function num2English(string) {
  return string
    .replace(/\u060C/g, ",")
    .replace(/[\u0660-\u0669]/g, function (c) {
      return c.charCodeAt(0) - 0x0660;
    })
    .replace(/[\u06f0-\u06f9]/g, function (c) {
      return c.charCodeAt(0) - 0x06f0;
    });
}
